'use client'

import React, { useEffect, useRef } from 'react'

import { cn } from '@telesoft/lib/web/cn'
import { CustomVideo } from '../../../../blocks/FullWidthDynamicBlock'
import { SERVER_BASE_URL } from '@telesoft/lib/web/constants'

export const Video: React.FC<CustomVideo> = props => {
  const { videoClassName, onClick, video } = props
  const { filename } = video

  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const { current: video } = videoRef
    if (video) {
      video.addEventListener('suspend', () => {})
    }
  }, [])
  if (video && typeof video !== 'string') {
    return (
      <video
        playsInline
        autoPlay
        muted
        loop
        controls={false}
        className={cn(`bg-primary/50 block w-full max-w-full`, {
          videoClassName,
        })}
        onClick={onClick}
        ref={videoRef}
      >
        <source src={`${SERVER_BASE_URL}/misc-assets/${filename}`} />
      </video>
    )
  }

  return null
}
